import { useEffect, useState } from 'react';
import { ArrowLeft, Download, FileText } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { loadMiscItem, miscFileKind } from '../lib/library';
import type { MiscItem } from '../lib/library';
import { parseFileUrl } from '../lib/parse';
import { Button, ErrorState, LoadingState } from '../components/ui';

export function StudentLibraryItem() {
  const { itemId = '' } = useParams();
  const [item, setItem] = useState<MiscItem>();
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    void loadMiscItem(itemId)
      .then((row) => { if (active) setItem(row); })
      .catch(() => { if (active) setFailed(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [itemId]);

  if (loading) return <LoadingState />;
  const kind = item ? miscFileKind(item) : 'other';
  const url = parseFileUrl(item?.Link);
  const categoryId = typeof item?.CatName === 'object' && item?.CatName ? (item.CatName as { objectId?: string }).objectId : undefined;
  if (!item || failed || !url) return <div className="library-page"><ErrorState onRetry={() => window.location.reload()} /></div>;
  return <div className="library-page">
    <Link className="back-link" to={categoryId ? `/library/${categoryId}` : '/library'}><ArrowLeft size={17} /> Library</Link>
    <section className="viewer-card">
      <header className="viewer-head">
        <span className="material-icon"><FileText size={17} /></span>
        <div><strong>{item.Name || item.Title || 'Untitled file'}</strong><small>{kind === 'pdf' ? 'PDF document' : 'Image'}{item.Description ? ` · ${item.Description}` : ''}</small></div>
      </header>
      {kind === 'pdf'
        ? <iframe className="viewer-frame" src={url} title={item.Name || item.Title || 'PDF viewer'} />
        : <a href={url} target="_blank" rel="noreferrer"><img className="viewer-image" src={url} alt={item.Name || item.Title || 'Study material'} loading="lazy" /></a>}
      <footer className="viewer-actions">
        <a href={url} target="_blank" rel="noreferrer"><Button variant="soft" icon={Download}>Open / download</Button></a>
      </footer>
    </section>
  </div>;
}
